<template>
    <div class="mb-3" :style="style">
        <label v-if="label" :for="id" class="form-label">{{ label }}</label>
        <input v-model="modelValue" :type="type" :id="id" :class="['form-control', { 'is-invalid': hasError }]"
            :placeholder="placeholder" :required="required" @change="onChange" />
        <div v-if="hasError">
            <small class="text-danger">{{ errorMessage }}</small>
        </div>
    </div>
</template>

<script>
import { read } from 'xlsx';

export default {
    name: "TextInput",
    props: {
        label: {
            type: String,
            required: false,
        },
        modelValue: {
            type: String,
            required: true,
        },
        id: {
            type: String,
            default: "text-input",
        },
        placeholder: {
            type: String,
            default: "",
        },
        type: {
            type: String,
            default: "text",
        },
        errorMessage: {
            type: String,
            default: "",
        },
        required: {
            type: Boolean,
            default: false,
        },
        style: {
            type: String,
            default: "",
        },
        onChange: {
            type: Function,
            default: () => { },
        },
    },
    computed: {
        hasError() {
            return this.errorMessage !== "";
        },

        localValue: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit("update:modelValue", value);
            }
        }
    },

    methods: {
        handleChange(event) {
            if (this.onChange) {
                this.onChange(event);
            }
        }
    },
    emits: ["update:modelValue"],
};
</script>